import { useCreateEvent } from "@/features/events/hooks/useCreateEvent"
import { EventType as NewEventType } from "@/features/events/types/EventType"
import { useOcr } from "@/features/ocr/hooks/useOcr"
import { LoadingOverlay } from "@/features/shared/components/Loaders"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { saveEvent } from "../../../utils/apis/user-service"
import { EventType } from "../../../utils/enums/EventType"
import { useAuthStore } from "../../../utils/stores/useAuthStore"
import { useUserStore } from "../../../utils/stores/useUserStore"
import FolderCard from "../../shared/components/FolderCard"

const DiagnosticaCards = [
  {
    route: "/reports",
    title: "📂 I tuoi Referti",
  },
  {
    route: "/parameters",
    title: "📈 Andamento parametri",
    disabled: true, // Will be dynamically set based on OCR documents count
  },
  {
    route: "/uploaded-from-user",
    title: "🗂️ Documenti caricati da te",
  },
  {
    route: "/uploaded-from-expert",
    title: "🗂️ Documenti caricati per te",
  },
  {
    route: "/health-assessment",
    title: "📝 Health Assessment",
  },
  {
    route: "/holifya-tests",
    title: "🧪 Test di laboratorio Holifya",
  },
]

const Diagnostica = () => {
  const { auth } = useAuthStore()
  const idToken = auth.idToken
  const { userData } = useUserStore()
  const email = userData.email
  const navigate = useNavigate()
  const { sendEvent } = useCreateEvent()

  const { isOcrAvailable, data: ocrData, isLoading: isOcrLoading } = useOcr()

  useEffect(() => {
    if (!email || !idToken) return
    saveEvent(
      email,
      EventType.PageView,
      (success) => { console.log() },
      (error) => { console.log(error) },
      "diagnostica_page",
    )

    void sendEvent({
      event: NewEventType.PAGE_VIEW,
      sub_category: "diagnostica_page",
    })
  }, [email, idToken, sendEvent])

  // Show loading state while OCR data is being fetched
  if (isOcrLoading) {
    return (
      <div className="relative w-full h-full">
        <LoadingOverlay />
      </div>
    )
  }

  const filteredCards = DiagnosticaCards.filter(card => {
    // Hide reports and parameters if OCR is not available
    if (card.title.includes("Referti") && !isOcrAvailable) return false
    
    // For parameters card, check if we have at least 2 OCR documents
    if (card.title.includes("parametri")) {
      if (!isOcrAvailable) return false
      const hasEnoughDocuments = (ocrData?.length ?? 0) >= 2
      card.disabled = !hasEnoughDocuments
      return hasEnoughDocuments
    }
    
    return true
  })

  const onCardClick = async (card: { route: string, title: string, disabled?: boolean }) => {
    if (card.disabled) return
    navigate(card.route)
    await sendEvent({
      event: NewEventType.CLICK,
      sub_category: "diagnostica_card",
      event_metadata: { card: card.title },
    })
  }

  return (
    <div className="w-full h-full flex flex-col space-y-sm mt-[20px]">
      {
        filteredCards.map((card, index) => (
          <FolderCard 
            key={`${card.title}-${index}`} 
            onClick={() => onCardClick(card)} 
            title={card.title}
            disabled={card.disabled}
          />
        ))
      }
      <div className="p-[10px]" />
    </div>
  )
}

export default Diagnostica
